import { BaseRouteService } from 'core/services';

class FulfillmentOrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-orders/';
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	select(filter) {
		return super.create(this.base + 'select', filter);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	getFulfillmentOrdersForLabeling(filter) {
		return super.create(this.base + 'get-fulfillment-orders-for-labeling', filter);
	}

	getCloseoutOrders(filter) {
		return super.create(this.base + 'get-closeout-orders', filter);
	}

	getFulfillmentOrderShipment(upc, sourceOfChange) {
		return super.get(this.base + 'get-fulfillment-order-shipment/{id}/?sourceOfChange={sourceOfChange}', upc, {
			sourceOfChange,
		});
	}

	toggleProductionMode(id, productionMode, sourceOfChange) {
		return super.update(
			this.base + 'production-mode/?id={id}&productionMode={productionMode}&sourceOfChange={sourceOfChange}',
			null,
			{ id, productionMode, sourceOfChange }
		);
	}

	countFulfillmentOrdersByStatus(filter) {
		return super.create(this.base + 'count', filter);
	}

	updateBuyShippingBulk(items, sourceOfChange) {
		return super.get(this.base + 'update-buyshipping-bulk/?sourceOfChange={sourceOfChange}', items, { sourceOfChange });
	}

	scanLabel(resource, sourceOfChange) {
		return super.update(this.base + 'scan-label/{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	cancelFulfillmentOrder(resource, sourceOfChange) {
		return super.update(this.base + 'cancel/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	cancelFulfillmentOrdersBulk(cancelParams, sourceOfChange) {
		return super.update(this.base + 'cancel-bulk/?sourceOfChange={sourceOfChange}', cancelParams, { sourceOfChange });
	}

	uncancelFulfillmentOrder(resource, sourceOfChange) {
		return super.update(this.base + 'uncancel/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	onHold(onHoldParams, sourceOfChange) {
		return super.update(this.base + 'on-hold/?sourceOfChange={sourceOfChange}', onHoldParams, { sourceOfChange });
	}

	onHoldBulk(onHoldBulkParams, sourceOfChange) {
		return super.update(this.base + 'on-hold-bulk/?sourceOfChange={sourceOfChange}', onHoldBulkParams, {
			sourceOfChange,
		});
	}

	undoPackaged(undoPackageParams, sourceOfChange) {
		return super.update(this.base + 'undo-package/?sourceOfChange={sourceOfChange}', undoPackageParams, {
			sourceOfChange,
		});
	}

	createWarehouseOrders(fulfillmentOrderIds) {
		return super.create(this.base + 'create-warehouse-orders', fulfillmentOrderIds);
	}

	validateOrderAddress(resource) {
		return super.update(this.base + 'verify-fulfillment-order-address', resource);
	}

	reoptimize(sourceOfChange) {
		return super.update(this.base + 'reoptimize/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	changeWarehouseShipByDate(sourceOfChange) {
		return this.uriTemplateService
			.parse(`${this.base}change-warehouse-ship-by-date/?sourceOfChange={sourceOfChange}`)
			.expand({ sourceOfChange });
	}

	getDistinctValues() {
		return super.create(this.base + 'get-distinct-values');
	}

	getRelatedFulfillmentOrders(id) {
		return super.get(this.base + `${id}/related-fulfillment-orders`);
	}

	getAdditionalDocuments(id) {
		return super.get(this.base + `${id}/additional-documents`);
	}

	updateWhShipByDate(sourceOfChange) {
		return super.update(this.base + 'update-wh-ship-by-date/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	confirmShipment(sourceOfChange) {
		return super.update(this.base + 'confirm-fulfillment-order/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}
}

export default FulfillmentOrderRouteService;
